import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { Injectable, inject } from '@angular/core';
import * as actions from './rfr-mon-stacks.actions';
import { SharedErrorObjectI } from 'src/app/shared/models/shared/shared-error-object.interface';
import { SharedGenericService } from 'src/app/shared/services/shared-generic.service';
import { spxToasterActions, SpxToasterAutoCloseSpeedEnum } from '@softpak/components/spx-toaster';


import { ApiRfrMethod } from 'src/app/api/api-methods.rfr';
import { RfrMonStacksResponseI } from 'src/app/api/rfr-mon-stacks/rfr-mon-stacks.result.int';

@Injectable()
export class RfrMonStacksEffects {
  private readonly actions$ = inject(Actions);
  private readonly sharedGenericService = inject(SharedGenericService);


  load$ = createEffect(() =>
    this.actions$.pipe(ofType(actions.load),
      mergeMap(() => this.sharedGenericService.invoke(ApiRfrMethod.rfrMonStacks, {}).pipe(
        map((data: RfrMonStacksResponseI) => actions.received({ data: data.locations })),
        catchError((error: SharedErrorObjectI) => [actions.error({ messageText: error.message })])
      ))
    ));

  onError$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(actions.error),
    mergeMap((action: { messageText: string }) => {
      return [
        spxToasterActions.createError({
          autoClose: SpxToasterAutoCloseSpeedEnum.DEFAULT,
          messageText: action.messageText,
        })
      ]
    })
  )
  );

  afterReceived$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(actions.received),
    mergeMap(() => [
      // actions.CREATE_SUCCESS({
      //     messageText: `Appointment ${result.data.piVBSBookingNr} added`,
      //     autoClose: SpxToasterAutoCloseSpeedEnum.SLOW,
      // }),
    ]))
  );
}
